function o(t, u) {
  let e;
  return function(...n) {
    clearTimeout(e), e = setTimeout(() => {
      t(...n);
    }, u);
  };
}
export {
  o as u
};
//# sourceMappingURL=nextgenDebounce-955bbcd7.mjs.map
